// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-card-container {
  padding: 0 20px 80px;
  margin-top: 80px;
}
@media screen and (min-width: 768px) {
  .preview-card-container {
    padding: 0 20px 150px;
    margin-top: 140px;
  }
}
.preview-card-container {
  color: white;
}
.preview-card-container .counter-container {
  justify-content: center;
  display: flex;
  padding: 15px 0 40px;
  border-bottom: 0.5px solid #BFBFBF;
}
@media screen and (min-width: 768px) {
  .preview-card-container .counter-container {
    padding: 48px 0 148px;
  }
}
.preview-card-container .counter-container .counter-items {
  max-width: 1200px;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  list-style: none;
}
.preview-card-container .counter-container .counter-items .counter-item {
  width: 100%;
  text-align: center;
}
.preview-card-container .counter-container .counter-items .counter-item h1 {
  font-size: 40px;
  line-height: 45px;
}
.preview-card-container .counter-container .counter-items .counter-item p {
  font-size: 16px;
  line-height: 25px;
}
.preview-card-container .counter-container .counter-items .counter-item {
  padding: 20px 10px;
}
@media screen and (min-width: 768px) {
  .preview-card-container .counter-container .counter-items .counter-item {
    width: 33.33%;
  }
}
@media screen and (min-width: 1024px) {
  .preview-card-container .counter-container .counter-items .counter-item {
    width: 20%;
  }
}
.preview-card-container .sub-heading {
  padding-top: 76px;
}
@media screen and (min-width: 768px) {
  .preview-card-container .sub-heading {
    padding: 145px 0 24px;
  }
}
.preview-card-container .form-container {
  width: 100%;
  max-width: 726px;
  padding: 0 18px;
}
.preview-card-container .form-container .MuiTextField-root {
  margin-bottom: 15px !important;
}
@media screen and (min-width: 768px) {
  .preview-card-container .form-container .MuiTextField-root.halfWidth {
    width: 50% !important;
  }
  .preview-card-container .form-container .MuiTextField-root.halfWidth:nth-child(odd) {
    width: calc(50% - 15px) !important;
    margin-right: 15px;
  }
}
.preview-card-container .form-container .date-container {
  margin: 20px 0px;
}
.preview-card-container .form-container .preview-header-action {
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}
@media screen and (min-width: 768px) {
  .preview-card-container .form-container .preview-header-action {
    margin-top: 35px;
  }
}
.preview-card-container .form-container .preview-header-action button {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .preview-card-container .form-container .preview-header-action button {
    width: 50%;
    margin: 0;
  }
  .preview-card-container .form-container .preview-header-action button:first-child {
    width: calc(50% - 15px);
    margin-right: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/issue-card/finalStep/finalStep.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,gBAAA;AACF;AAAE;EAHF;IAII,qBAAA;IACA,iBAAA;EAGF;AACF;AATA;EAOE,YAAA;AAKF;AAJE;EACE,uBAAA;EACA,aAAA;EACA,oBAAA;EACA,kCAAA;AAMJ;AALM;EALJ;IAMI,qBAAA;EAQJ;AACF;AAPI;EACI,iBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AASR;AARQ;EACI,WAAA;EACA,kBAAA;AAUZ;AATY;EACI,eAAA;EACA,iBAAA;AAWhB;AATY;EACI,eAAA;EACA,iBAAA;AAWhB;AApBQ;EAWI,kBAAA;AAYZ;AAVY;EAbJ;IAcM,aAAA;EAaZ;AACF;AAZY;EAhBJ;IAiBM,UAAA;EAeZ;AACF;AARE;EACE,iBAAA;AAUJ;AATI;EAFF;IAGI,qBAAA;EAYJ;AACF;AAVE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAYJ;AAXI;EACE,8BAAA;AAaN;AAXQ;EADF;IAEI,qBAAA;EAcR;EAbQ;IACE,kCAAA;IACA,kBAAA;EAeV;AACF;AAXI;EACE,gBAAA;AAaN;AAXI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAaN;AAZM;EAJF;IAKG,gBAAA;EAeL;AACF;AAdM;EACE,WAAA;AAgBR;AAfQ;EAFF;IAGI,UAAA;IACA,SAAA;EAkBR;EAjBQ;IACE,uBAAA;IACA,kBAAA;EAmBV;AACF","sourcesContent":[".preview-card-container {\n  padding: 0 20px 80px;\n  margin-top: 80px;\n  @media screen and (min-width: 768px) {\n    padding: 0 20px 150px;\n    margin-top: 140px;\n  }\n  color: white;\n  .counter-container{\n    justify-content: center;\n    display: flex;\n    padding: 15px 0 40px;\n    border-bottom: 0.5px solid #BFBFBF;\n      @media screen and (min-width: 768px) {\n      padding: 48px 0 148px;\n    }\n    .counter-items{\n        max-width: 1200px;\n        width: 100%;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        list-style: none;\n        .counter-item{\n            width: 100%;\n            text-align: center;\n            h1{\n                font-size: 40px;\n                line-height: 45px;\n            }\n            p{\n                font-size: 16px;\n                line-height: 25px;\n            }\n            padding: 20px 10px;\n            \n            @media screen and (min-width: 768px) {\n              width: 33.33%;\n            }\n            @media screen and (min-width: 1024px) {\n              width: 20%;\n            }\n            // @media screen and (min-width: 1024px) {\n            //     width: 25%;\n            // }\n        }\n    }\n  }\n  .sub-heading{\n    padding-top: 76px;\n    @media screen and (min-width: 768px) {\n      padding: 145px 0 24px;\n    }\n  }\n  .form-container{\n    width: 100%;\n    max-width: 726px;\n    padding: 0 18px;\n    .MuiTextField-root{\n      margin-bottom: 15px !important;\n      &.halfWidth{\n        @media screen and (min-width: 768px) {\n          width: 50% !important;\n          &:nth-child(odd){\n            width: calc( 50% - 15px ) !important;\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n    .date-container {\n      margin: 20px 0px;\n    }\n    .preview-header-action{\n      display: flex;\n      flex-wrap: wrap;\n      margin-top: 50px;\n      @media screen and (min-width: 768px) {\n       margin-top: 35px;\n      }\n      button{\n        width: 100%;\n        @media screen and (min-width: 768px) {\n          width: 50%;\n          margin:0;\n          &:first-child{\n            width: calc( 50% - 15px );\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
